import { useEffect, useRef } from "react";


export default function useAutoLoadMore({ hasMore, isLoading, onLoadMore, rootMargin = "640px 0px" }) {
  const targetRef = useRef(null);
  const loadMoreRef = useRef(onLoadMore);

  useEffect(() => {
    loadMoreRef.current = onLoadMore;
  }, [onLoadMore]);

  useEffect(() => {
    const node = targetRef.current;
    if (!node || !hasMore) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting && !isLoading) {
          loadMoreRef.current?.();
        }
      },
      {
        rootMargin,
        threshold: 0.1,
      }
    );

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [hasMore, isLoading, rootMargin]);

  return targetRef;
}
